import type { GateDefinition, GateContext } from './gates.types'
import { CONFIG_DDF_SMAVA_RCE_EDIT } from 'config/utils/config'
import { getRCEVoucherExperiment } from 'components/VoucherBanner/helpers/voucherExperiment'
import { PossibleVariants } from 'utils/tracking/optimizely/types'
import type { RCEVoucherActiveExperimentVariant } from 'components/VoucherBanner/VoucherBanner.types'
import { Experiments } from 'CustomOptimizelyProvider'
import { inExperiment } from './helpers'
import { isCat4784SmavaDacSkipButtonVarB } from './helpers/cat4784SmavaDacSkipButton'

const isRCEVoucherVariant = (
  context: GateContext,
  variant: RCEVoucherActiveExperimentVariant
) => {
  if (context.configName !== CONFIG_DDF_SMAVA_RCE_EDIT) return false

  const experiment = getRCEVoucherExperiment(context)
  if (!experiment) return false

  return context.experimentData[experiment] === variant
}

export const gates = {
  rceVoucherVariantB: {
    smava: (context) =>
      isRCEVoucherVariant(context, PossibleVariants.VARIATION_B)
  },
  rceVoucherVariantC: {
    smava: (context) =>
      isRCEVoucherVariant(context, PossibleVariants.VARIATION_C)
  },

  /** @cleanup CAT-4707 — smava voucher higher amounts Var B */
  cat4707SmavaVoucherVarB: {
    smava: inExperiment(
      Experiments.CAT_4707_SMAVA_VOUCHER_HIGHER_AMOUNTS,
      PossibleVariants.VARIATION_B
    )
  },
  /** @cleanup CAT-4784 — DAC skip button V5 */
  cat4784SmavaStandardDacExperiment: {
    smava: isCat4784SmavaDacSkipButtonVarB
  },
  // CAT-4561 Variant B/C only apply to single-debtor applications
  cat4561ContactPageVariation: {
    ffg: ({ experimentData, debtorsCount }: GateContext): boolean =>
      debtorsCount === 1 &&
      (experimentData[Experiments.CAT_4561_PROGRESSIVE_DISCLOSURE_FFG] ===
        PossibleVariants.VARIATION_B ||
        experimentData[Experiments.CAT_4561_PROGRESSIVE_DISCLOSURE_FFG] ===
          PossibleVariants.VARIATION_C)
  },
  /** @cleanup CAT-4561 — Variant C swaps contact field order (email before phone) */
  cat4561EmailFirstVariation: {
    ffg: (ctx: GateContext): boolean =>
      ctx.debtorsCount === 1 &&
      inExperiment(
        Experiments.CAT_4561_PROGRESSIVE_DISCLOSURE_FFG,
        PossibleVariants.VARIATION_C
      )(ctx)
  }
} satisfies Record<string, GateDefinition>

export type GateName = keyof typeof gates
